// @flow

import React, { type Element, Component } from "react";
import styled from "styled-components";
import { isEqual, noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";
import type { RaceStatus, ImportanceType, RaceListItem } from "@tvg/types/Race";

import buildColor from "../../_static/ColorPalette";
import RaceSelectorLine from "../../_organism/RaceNavigation";

type RaceSelectorType = {
  raceId: string,
  mtp: number,
  postTime: string,
  raceStatus: RaceStatus,
  isGreyhound?: boolean,
  trackName: string,
  trackAbbr: string,
  raceNumber: string,
  description: string,
  importanceLevel: ImportanceType,
  raceInfo: RaceListItem[],
  channel?: string
};

export type Props = {
  races: RaceSelectorType[],
  onNavigationCallback: NullaryFn<mixed>,
  channel?: string
};

export const renderList = (
  races: RaceSelectorType[],
  onNavigationCallback: NullaryFn<mixed>,
  channel: string = ""
): Array<React$Element<*>> =>
  races.map((race: RaceSelectorType): Element<*> => (
    <RaceSelectorLine
      key={`${race.raceNumber}-${race.trackAbbr}-nav-item`}
      channel={channel}
      mtp={race.mtp}
      postTime={race.postTime}
      status={race.raceStatus.code}
      isGreyhound={race.isGreyhound}
      trackName={race.trackName}
      trackAbbr={race.trackAbbr}
      raceNumber={race.raceNumber}
      description={race.description}
      importanceLevel={race.importanceLevel}
      raceInfo={race.raceInfo}
      isLink
      onClickCallback={onNavigationCallback}
    />
  ));

const RaceSelectorContainer = styled.div`
  background-color: ${buildColor("white", "100")};
`;

export default class RaceNavigationList extends Component<Props> {
  static defaultProps = {
    races: [],
    onNavigationCallback: noop,
    channel: ""
  };

  shouldComponentUpdate(nextProps: Props) {
    return !isEqual(nextProps, this.props);
  }

  render() {
    return (
      <RaceSelectorContainer>
        {!!this.props.races.length &&
          renderList(
            this.props.races,
            this.props.onNavigationCallback,
            this.props.channel
          )}
      </RaceSelectorContainer>
    );
  }
}
